import './main.css'
var d3 = require('d3')
var $ = require('jquery')

var marriage_intro = "<div class='title'>Expanding LGBT Rights and Protections</div>"

$("#marriage_map").append(marriage_intro);

var svgCont = "<svg id='marriage_svg'><div id='tooltip' class='hidden'></div></svg>"
$("#marriage_map").append(svgCont);

d3.select(window)
  .on("load", sizeChange)
  .on("resize", sizeChange);

var xy = d3.geoEquirectangular()
           .scale(160)

var path = d3.geoPath()
             .projection(xy)

var svg_m = d3.select("#marriage_svg")
  .call(d3.zoom().on("zoom", function(){
    svg_m.attr("transform", d3.event.transform)
    })
  )
  .append('g')

var states = svg_m.append("svg:g")
                .attr("id", "states");

var collection = require('./world-countries.json');

var csv = require('./marriage_data.csv');

states.selectAll("path")
      .data(collection.features)
      .enter().append("svg:path")
      .attr("d", path)
      .style("fill", function(d){
        if (d.properties.legal === 'y'){return "#e2b260"}
        else {return "#fffffa"}
            })
      .on("mouseover", function(d) {
              d3.select(this).style("fill","#0e2849");
              d3.select('#tooltip_marriage')
                 .style("left", d3.event.pageX - $('#marriage_map').offset().left + "px")
                 .style("top", d3.event.pageY - $('#marriage_map').offset().top + "px")
                 .html("<p class='tooltip_marriage'><span class='country'>" + d.properties.name + makeSquare01(d) + makeSquare02(d) + makeSquare03(d) + "</span></p><p>" + description(d) + "</p>");
                  d3.select('#tooltip_marriage').classed('hidden', false);
            })
      .on("mouseout", function(d) {
              d3.select(this).style("fill", hoverColour(d))
                d3.select('#tooltip_marriage').classed('hidden', true);
            });

function description(d){
  if (d.properties.desc != null){return d.properties.desc}
  else {return ""}
}

function makeSquare01(d){
  if (d.properties.legal === 'y'){return "<span class='legal_colour key_circle'></span>"}
  else {return ""}
}

function makeSquare02(d){
  if (d.properties.anti_disc === 'y') {return "<span class='anti_colour key_circle'></span>"}
  else {return ""}
}


function makeSquare03(d){
  if (d.properties.civil_unions === 'y') {return "<span class='civil_colour key_circle'></span>"}
  else {return ""}
}



function hoverColour(d){

  if($('#checkBox_legal').prop('checked')) {
          return function(d){
                if (d.properties.legal === 'y'){return "#e2b260"}
                else {return "#fffffa"}}
  } else if($('#checkBox_anti').prop('checked')) {
            return function(d){
              if (d.properties.anti_disc === 'y'){return "#773863"}
              else {return "#fffffa"}}
  } else if($('#checkBox_civil').prop('checked')) {
            return function(d){
              if (d.properties.civil_unions === 'y'){return "#99b782"}
              else {return "#fffffa"}}
            }
}


var marriage_options = "<div id='tooltip_marriage' class='hidden'></div><div id='option_bottom'>\n  <div class=\"check_option\">\n      <p><span style=\"background-color:#e2b260;color:white;padding:2px;\"><input id='checkBox_legal' type='checkbox' class='example check_style' checked>Same-sex marriage legal</span><br> <span class=\"detail\">Countries where same-sex couples may wed.</span></p>\n  </div>\n  <div class=\"check_option\">\n    <p><span style=\"background-color:#773863;color:white;padding:2px;\"><input id='checkBox_anti' type='checkbox' class='example check_style'>Antidiscrimination laws</span><br> <span class=\"detail\">Countries that offer some protections from discrimination on the basis of sexual orientation or gender identification.</span></p>\n  </div>\n  <div class=\"check_option\">\n    <p><span style=\"background-color:#99b782;color:white;padding:2px;\"><input id='checkBox_civil' type='checkbox' class='example check_style'>Some rights to same-sex couples</span><br> <span class=\"detail\">Countries that allow civil unions or grant same-sex couples some of the rights and protections associated with marriage.</span></p>\n  </div>\n</div>";

  $("#marriage_map").append(marriage_options);


var marriage_countryList = "<div class='countryList'><p><b>Countries not highlighted on this map:</b><br>Some rights for same-sex couples: Andorra, Liechtenstein</b><br>Antidiscrimination laws: Andorra, Cape Verde, Kiribati, Mauritius, Monaco, Saint Lucia, San Marino, Samoa, Seychelles, Tonga</p></div>"

var marriage_source = "<div class='source'><p><i>Sources:</i>Pew Research Center; Marriage Equality USA; ILGA.</p></div><div class='note'></div><div class='note-padding'><div class='note'></div></div>"

  $("#marriage_map").append(marriage_countryList);
  $("#marriage_map").append(marriage_source);



  $('#checkBox_legal').on('change', function() {
      showLegal();
  });

  $('#checkBox_anti').on('change', function() {
      showAnti();
  });

  $('#checkBox_civil').on('change', function() {
      showCivil();
  });



  function showLegal(){

    $("#checkBox_legal").prop('checked', true);
    $("#checkBox_civil").prop('checked', false);
    $("#checkBox_anti").prop('checked', false);

    hoverColour();

    states.selectAll("path")
        .transition().duration(1000)
          .style("fill", function(d){
            if (d.properties.legal === 'y'){return "#e2b260"}
            else {return "#fffffa"}
                })
  } // Show legal

  function showAnti(){
    $("#checkBox_legal").prop('checked', false);
    $("#checkBox_civil").prop('checked', false);
    $("#checkBox_anti").prop('checked', true);

    hoverColour();

    states.selectAll("path")
        .transition().duration(1000)
          .style("fill", function(d){
            if (d.properties.anti_disc === 'y'){return "#773863"}
            else {return "#fffffa"}
                })
  } // Show Anti

  function showCivil(){
    $("#checkBox_legal").prop('checked', false);
    $("#checkBox_civil").prop('checked', true);
    $("#checkBox_anti").prop('checked', false);

    hoverColour();

    states.selectAll("path")
        .transition().duration(1000)
          .style("fill", function(d){
            if (d.properties.civil_unions === 'y'){return "#99b782"}
            else {return "#fffffa"}
                })
  } // Show Civil



  function sizeChange() {
    d3.select("#states").attr("transform", "scale(" + $("#marriage_map").width()/1000 +")" );
    $("#marriage_svg").height($("#marriage_map").width()*0.418);
  }



//////////////////
// WEBPACK FOOTER
// ./static/apps/marriage_map/main.js
// module id = 829
// module chunks = 1